// extracted by mini-css-extract-plugin
export var addViewLink = "_18-1";
export var availabilityIcon = "_18-16";
export var availabilitySelectionIcon = "_18-15";
export var backButton = "_18-2";
export var backIcon = "_18-z";
export var conversationCount = "_18-3";
export var dragHandle = "_18-5";
export var dropdown = "_18-e";
export var dropdownIcon = "_18-7";
export var dropdownOption = "_18-6";
export var dropdownTriangle = "_18-d";
export var expand = "_18-f";
export var folder = "_18-i";
export var folderItem = "_18-c";
export var icon = "_18-8";
export var iconRow = "_18-9";
export var image = "_18-a";
export var logo = "_18-b";
export var navContainer = "_18-h";
export var navigationFooter = "_18-g";
export var pageShell = "_18-0";
export var placeholderAvailable = "_18-11";
export var placeholderBox = "_18-14";
export var placeholderBusy = "_18-13";
export var placeholderUnavailable = "_18-12";
export var profile = "_18-k";
export var profileContainer = "_18-m";
export var profileDropdown = "_18-n";
export var profileImage = "_18-l";
export var profileMain = "_18-o";
export var profileSubtitle = "_18-q";
export var profileTitle = "_18-p";
export var reorderIcon = "_18-r";
export var sentLine = "_18-u";
export var settingsHeader = "_18-s";
export var sidenavTextColor = "_18-y";
export var spamLine = "_18-t";
export var subitemWithTag = "_18-4";
export var supportItems = "_18-j";
export var teamText = "_18-10";
export var viewLine = "_18-x";
export var viewLineButton = "_18-w";
export var viewLineButtons = "_18-v";